module.exports = __webpack_public_path__ + "static/media/logo_native.ff541e7c.svg";